var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    separatorPadding: spacing.small,
    filterItemPadding: spacing.xxSmall,
    sectionWrapperPadding: spacing.medium,
    fontFamily: typography.fontFamily,
    fontSize: typography.fontSizeSmall,
    boldFontWeight: typography.fontWeightBold
  };
};
export default generateComponentTheme;